import React from 'react';
import useAtlasV2KeywordSearchRequestBuilder from 'src/components/AtlasV2Components/AtlasV2Sidebar/AtlasV2SearchSidebar/useAtlasV2KeywordSearchRequestBuilder';
import { AtlasV2KeywordAdClicksColumnChart } from 'src/components/AtlasV2Components/AtlasV2TopicPageComponents/AtlasV2KeywordAdClicksColumnChart';
import AtlasV2KeywordAdClicksSplineChart from 'src/components/AtlasV2Components/AtlasV2TopicPageComponents/AtlasV2KeywordAdClicksSplineChart';
import AtlasV2KeywordSearchOrganicTrafficSpline from 'src/components/AtlasV2Components/AtlasV2TopicPageComponents/AtlasV2KeywordSearchOrganicTrafficSpline';
import AtlasV2TopicBuilderColumnChart from 'src/components/AtlasV2Components/AtlasV2TopicPageComponents/AtlasV2TopicBuilderColumnChart';
import AtlasV2MetricListContainer from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricListContainer';
import { BeaconProSidebarFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/Filters/constants';
import {
  FILTER_OPERATION,
  useSavedSearchBuilder
} from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/hooks/useSavedSearchBuilder';
import { KeywordColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { SlCancelButton } from 'src/components/BeaconV2Components/SlButtons/SlCancelButton';

/**
 * Used for the legacy topic builder.
 * Renders a table containing keywords and their metrics and additional visualizations that are filtered via sidebar.
 */
export const AtlasV2TopicBuilderCreateResults = () => {
  const [hoveredIndex, setHoveredIndex] = React.useState(null);

  const { updateSavedSearch } = useSavedSearchBuilder();
  const keywordSearchRequestBuilder = useAtlasV2KeywordSearchRequestBuilder();
  // Handles quick exclude button click
  const handleExcludeButtonClick = (term: string) => {
    updateSavedSearch({
      operation: FILTER_OPERATION.Add,
      key: BeaconProSidebarFilters.ExcludedSearchTerm.filterKey,
      newValue: term
    });
  };

  const additionalColumnDefs = [
    {
      headerName: '',
      tableColumnProps: {
        style: {
          width: '50px'
        }
      },
      valueFormatter: (_, row, index) => {
        const { searchTerm } = row;

        if (hoveredIndex === index) {
          return <SlCancelButton onClick={() => handleExcludeButtonClick(searchTerm)} />;
        } else {
          return null;
        }
      }
    }
  ];

  return (
    <>
      <AtlasV2MetricListContainer
        appTableProps={{
          onRowEnter: (_u, _w, index) => setHoveredIndex(index),
          onRowLeave: () => setHoveredIndex(null)
        }}
        additionalColumnDefs={additionalColumnDefs}
        loading={false}
        headColumnDefinition={KeywordColumnDefinition}
        fields={[
          {
            name: 'organicClicks',
            comparisonFormatter() {
              return null;
            }
          },
          {
            name: 'adClicks',
            comparisonFormatter() {
              return null;
            }
          },
          {
            name: 'totalClicks',
            comparisonFormatter() {
              return null;
            }
          },
          {
            name: 'adSpend',
            comparisonFormatter() {
              return null;
            }
          }
        ]}
        showHeader={false}
        showGrid={false}
        indexName="traffic"
        sortFieldName="totalClicks"
        groupBy="searchTerm"
        skeletonRows={20}
        useTableDataProps={{
          buildRequest: keywordSearchRequestBuilder()
        }}
      />
      <AtlasV2KeywordSearchOrganicTrafficSpline />
      <AtlasV2TopicBuilderColumnChart />
      <AtlasV2KeywordAdClicksSplineChart />
      <AtlasV2KeywordAdClicksColumnChart />
    </>
  );
};
